import PageContainer from '../../../../components/common/PageContainer';
import EJOApprovedAndESRUncreatedTable from './Table';

const EJOApprovedAndESRUncreatedPage = () => {
  return (
    <>
      <PageContainer 
        title='My Dashboard + Tasks' 
        subTitle='My MRRF & JO'
        submoduleTitle='MRRF Approved, JO Uncreated' 
        showDate
      >
        <EJOApprovedAndESRUncreatedTable/>
      </PageContainer>
    </>
  );
}

export default EJOApprovedAndESRUncreatedPage;